/**
 * RBAC permission matrix (PRD: Administrator, Driver, Finance, Integration service).
 */
import { ROLES } from './constants.js';
export const PERMISSIONS = [
    // Jobs
    'jobs:read',
    'jobs:create_manual',
    'jobs:edit',
    'jobs:cancel',
    'jobs:allocate',
    'jobs:reassign',
    'jobs:override_capacity',
    'jobs:transition',
    'jobs:export',
    // Fleet & people
    'drivers:read',
    'drivers:manage',
    'vehicles:read',
    'vehicles:manage',
    // Commercial data
    'clients:read',
    'clients:manage',
    'locations:read',
    'locations:manage',
    'pricing:read',
    'pricing:manage',
    'pricing:override',
    // Finance
    'invoices:read',
    'invoices:create',
    'invoices:edit',
    'invoices:send',
    'invoices:void',
    'payments:record',
    // Evidence
    'proofs:create',
    'exceptions:create',
    // Platform
    'analytics:read',
    'analytics:export',
    'audit:read',
    'users:read',
    'users:manage',
    'settings:read',
    'settings:manage',
    'intake:submit',
    // Sales leads (public quote form → admin pipeline)
    'leads:read',
    'leads:manage',
];
const FINANCE_PERMISSIONS = [
    'jobs:read',
    'jobs:transition',
    'jobs:export',
    'drivers:read',
    'vehicles:read',
    'clients:read',
    'locations:read',
    'pricing:read',
    'pricing:override',
    'invoices:read',
    'invoices:create',
    'invoices:edit',
    'invoices:send',
    'invoices:void',
    'payments:record',
    'analytics:read',
    'analytics:export',
    'audit:read',
    'settings:read',
    'leads:read',
];
const DRIVER_PERMISSIONS = [
    'jobs:read',
    'jobs:transition',
    'proofs:create',
    'exceptions:create',
];
const INTEGRATION_PERMISSIONS = ['intake:submit', 'jobs:read', 'jobs:transition'];
const READ_PERMISSIONS = [
    'jobs:read',
    'drivers:read',
    'vehicles:read',
    'clients:read',
    'locations:read',
    'pricing:read',
    'invoices:read',
    'analytics:read',
];
export const ROLE_PERMISSIONS = Object.freeze({
    ADMIN: Object.freeze([...new Set([...PERMISSIONS])]),
    FINANCE: Object.freeze([...new Set([...READ_PERMISSIONS, ...FINANCE_PERMISSIONS])]),
    DRIVER: Object.freeze([...DRIVER_PERMISSIONS]),
    INTEGRATION: Object.freeze([...INTEGRATION_PERMISSIONS]),
});
export function permissionsForRole(role) {
    return [...(ROLE_PERMISSIONS[role] ?? [])];
}
export function can(role, permission) {
    return (ROLE_PERMISSIONS[role] ?? []).includes(permission);
}
export function canAny(role, permissions) {
    return permissions.some((p) => can(role, p));
}
export function canAll(role, permissions) {
    return permissions.every((p) => can(role, p));
}
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
/** Roles allowed to perform a job status transition (mirrors job-status rules). */
export function roleCanSeeFinancials(role) {
    return role === 'ADMIN' || role === 'FINANCE';
}
//# sourceMappingURL=rbac.js.map